<div class="setting-page">
    <legend>Security Policies</legend>

    <div class="header">
        <div class="search-container">
            <client-filter (onFilter)="onFilter($event)"></client-filter>
        </div>

        <div class="action-buttons">
            <arm-action-bar (addClick)="addItem()" [disableAdd]="!canSubmit"
                            (deleteClick)="removeItem()" [disableDelete]="!canSubmit || !selection || selection.default"
                            (refreshClick)="refresh()"
                            (editClick)="editItem()" [disableEdit]="!canSubmit || !selection"></arm-action-bar>
        </div>
    </div>

    <div class="security-policies-table">
        <arm-table [displayedColumns]="displayedColumns"
                   (onSelection)="onSelection($event)" [data]="items"
                   [isMultipleSelection]="false" [filter]="filter"
                   [isClientSide]="true"></arm-table>
    </div>
</div>
